import React from "react";
import { ViewMode } from "gantt-task-react";
import styles from "./timeline.module.scss";
import { KoButton, KoDropdown, KoText, KoTitle } from "packages";
import KoIcon from "@kwapio/icons";


const VIEW_OPTIONS = [
//   { key: ViewMode.Hour, label: "Hour" },
//   { key: ViewMode.QuarterDay, label: "Quarter Day" },
//   { key: ViewMode.HalfDay, label: "Half Day" },
  { key: ViewMode.Day, label: "Day" },
  { key: ViewMode.Week, label: "Week" },
  { key: ViewMode.Month, label: "Month" },
  { key: ViewMode.Year, label: "Year" }
//   { key: ViewMode.QuarterYear, label: "Quarter Year" }
];

// const FILTER = [
//   { key: 'workspace', label: "By Workspace" },
//   { key: 'sprint', label: "By Sprint" }
// ];


export const ViewSwitcher = ({ viewMode='Day', filterMode='workspace', onViewModeChange, setOpenCurdModal }) => {
  return (
    <div className={styles.viewSwitcher}>
      <KoTitle text="Project Timeline" level={4} className={styles.label} />
      <div className={styles.viewContainer}>
        <KoButton onClick={() => setOpenCurdModal(true)} type="primary" label="Add Task" icon={<KoIcon name="PlusOutlined" color="#FFF" width={20} height={20} />} />
        {/* <KoDropdown.Button
          icon={<KoIcon name="DownArrowOutlined" color="#FFF" width={10} height={10} />}
          menu={{
            items: FILTER,
            onClick: ({ key }) => onViewModeChange(key)
          }}
          placement="bottomRight"
        >
          <KoText text={FILTER.find(item => item.key === filterMode)?.label} />
        </KoDropdown.Button> */}
        <KoDropdown.Button
          icon={<KoIcon name="DownArrowOutlined" color="#FFF" width={10} height={10} />}
          menu={{
            items: VIEW_OPTIONS,
            onClick: ({ key }) => onViewModeChange(key)
          }}
          placement="bottomRight"
        >
          <KoText text={VIEW_OPTIONS.find(item => item.key === viewMode)?.label} />
        </KoDropdown.Button>
      </div>
    </div>
  );
};
